const handleChangeNumberOnly = ({ event, onChange, setValue }) => {
  const reg = /^[0-9\b]+$/;
  if (event.target.value === '' || reg.test(event.target.value)) {
    onChange(event);
    setValue(event.target.value);
  }
};

export default handleChangeNumberOnly;
